module.exports = __webpack_public_path__ + "img/login_top2.80b844c1.png";